import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { pages } from '../js/config'
import StateContext from '../state'
import { StyledNavbar } from '../styles'

const Navbar = () => {
  const [navOpen] = useContext(StateContext)

  return (
    <>
      <StyledNavbar className={navOpen ? 'is-open' : ''}>
        <header>
          <h1>
            <Link to="/">Phil Sinatra</Link>
          </h1>
        </header>
        {pages.map(item => (
          <React.Fragment key={uuidv4()}>
            <h2>{item.course}</h2>
            <ul>
              {item.pages.map(({ target, title, url }) => {
                return (
                  <li key={uuidv4()}>
                    {target ? (
                      <a href={url} target={target} rel="noopener noreferrer">
                        {title}
                      </a>
                    ) : (
                      <Link to={url}>{title}</Link>
                    )}
                  </li>
                )
              })}
            </ul>
          </React.Fragment>
        ))}
      </StyledNavbar>
    </>
  )
}

Navbar.propTypes = {
  navOpen: PropTypes.bool,
}

export default Navbar
